import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { AddPlusIcon } from '../../assets/icons';
import { RemoveAllWhiteSpaceFromString } from '../../helpers/jsHelper';
import { USER_PROFILE_PLACEHOLDER } from '../../config/constant/assetConstant';
import styles from './FilterItem.module.scss';

export const FilterItem = ({
  title,
  items,
  maxVisible,
  value,
  onChange,
  designV2 = null,
  viewMore = null,
  page = 1,
  total,
  total_pages,
}) => {
  const [open, setOpen] = useState(false);
  const moreCount = items?.length - maxVisible;
  const visibleItems = moreCount > 0 && !open ? items?.slice(0, maxVisible) : items;
  
  const getLabelId = () => {
    let firstItemValue = visibleItems?.[0]?.value;
    if (!firstItemValue.includes('option_')) return '';
    return firstItemValue.split('_')?.[1];
  };

  const getPageNumber = () => {
    if (!total) return 1;
    return total_pages > page ? page + 1 : page;
  };

  const count = useMemo(() => {
    return viewMore ? total - visibleItems.length : moreCount;
  }, [total, visibleItems, viewMore, moreCount]);

  const getActionLabel = useCallback(() => {
    let label = `View more (${count})`;

    if (viewMore) {
      if (open) {
        if (total_pages === page) {
          label = 'Show less';
        }
      } else {
        if (total_pages === page) {
          label = `Show more (${count})`;
        }
      }
    } else {
      if (open) label = 'Show less';
    }

    return label;
  }, [open, total_pages, page, viewMore, count]);

  return (
    <>
      {designV2 ? (
        <>
          <div className={`${styles.root} filter-root-item accordion-item`}>
            {title && (
              <div>
                <h5
                  className="accordion-header"
                  id={`panelsStayOpen-heading${RemoveAllWhiteSpaceFromString(title?.trim())}`}>
                  <div
                    className="accordion-button d-flex justify-content-between"
                    data-bs-toggle="collapse"
                    data-bs-target={`#panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                      title?.trim()
                    )}`}
                    aria-expanded="true"
                    aria-controls={`panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(
                      title?.trim()
                    )}`}>
                    <div className="main-text">{title}</div>
                  </div>
                </h5>
              </div>
            )}
            <div
              id={`panelsStayOpen-collapse${RemoveAllWhiteSpaceFromString(title?.trim())}`}
              className="accordion-collapse collapse show"
              aria-labelledby={`panelsStayOpen-heading${RemoveAllWhiteSpaceFromString(
                title?.trim()
              )}`}>
              {visibleItems?.map((item) => {
                return (
                  <div
                    className={`form-check custom-checkbox ${
                      item?.type === 'team' ? 'team-member' : ''
                    }`}
                    key={item?.value}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={item?.value}
                      checked={value?.includes(item?.value) || item?.checked}
                      onChange={() => onChange(item?.value)}
                      id={`sideFilter-${item?.value}`}
                    />
                    <label className="form-check-label" htmlFor={`sideFilter-${item?.value}`}>
                      <div className="team-profile-img">
                        {item?.type === 'team' && (
                          <img
                            src={item?.all?.user?.profile_image || USER_PROFILE_PLACEHOLDER}
                            alt="profile"
                          />
                        )}{' '}
                        {`${item?.label?.charAt(0)?.toUpperCase()}${item?.label
                          ?.slice(1)
                          ?.toLowerCase()}`}
                      </div>
                    </label>
                  </div>
                );
              })}
              {moreCount > 0 && (
                <div className={`${styles.more} more`}>
                  <span
                    className={`${
                      (open && viewMore && total_pages === page) || (open && !viewMore)
                        ? 'show-more'
                        : ''
                    } more-option`}
                    onClick={() => {
                      if (viewMore && total_pages !== page) {
                        setOpen(true);
                        viewMore?.({ labelId: getLabelId(), page: getPageNumber() });
                      } else setOpen(!open);
                    }}>
                    <>
                      <AddPlusIcon />
                      {getActionLabel()}
                    </>
                  </span>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <div className={styles.root}>
          {title && (
            <div>
              <h5>{title}</h5>
            </div>
          )}

          {visibleItems.map((item) => {
            return (
              <div className="form-check custom-checkbox" key={item.value}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={item.value}
                  checked={value?.includes(item.value) || item?.checked}
                  onChange={() => onChange(item.value)}
                  id={`sideFilter-${item.value}`}
                />
                <label className="form-check-label" htmlFor={`sideFilter-${item.value}`}>
                  {`${item.label.charAt(0).toUpperCase()}${item.label.slice(1).toLowerCase()}`}
                </label>
              </div>
            );
          })}

          {moreCount > 0 && (
            <div className={styles.more}>
              <span onClick={() => setOpen(!open)}>
                {!open && `${moreCount} more`}
                {open && 'Show less'}
              </span>
            </div>
          )}
        </div>
      )}
    </>
  );
};
